import AgentLogoMark from "@/components/chat/AgentLogoMark";

/**
 * Human-agent avatar for inbox message rows.
 * @param {{ className?: string, size?: "sm" | "md", variant?: "agent" | "note", logoUrl?: string | null }} props
 */
export default function AgentMessageAvatar({ className = "", size = "md", variant = "agent", logoUrl = null }) {
  const dim = size === "sm" ? "h-7 w-7" : "h-8 w-8";
  const ring =
    variant === "note"
      ? "ring-2 ring-amber-100 shadow-md dark:ring-amber-900/60"
      : "ring-2 ring-teal-100 shadow-md dark:ring-teal-900/60";
  return (
    <span
      aria-hidden
      className={`${dim} shrink-0 overflow-hidden rounded-full ${ring} ${className}`.trim()}
    >
      {logoUrl ? (
        <img src={logoUrl} alt="" className="h-full w-full object-cover" />
      ) : (
        <AgentLogoMark />
      )}
    </span>
  );
}
